import React, { useState } from "react"
import { Button, Modal, Form, Col } from "react-bootstrap"
import { useStore } from "../components/StoreContext"

const CheckoutModal = props => {
  const { state } = useStore()

  const store = state?.items ?? []
  var products = store.map(function (item) {
    return item.title
  })

  const initialState = {
    merchant_id: process.env.GATSBY_MERCHANT_ID,
    merchant_key: process.env.GATSBY_MERCHANT_KEY,
    amount: state && state.total,
    item_name: products.join(),
    return_url: process.env.GATSBY_PAYMENTRETURNURL,
    cancel_url: process.env.GATSBY_PAYMENTCANCELRETURNURL,
    notify_url: "",
    name_first: "",
    name_last: "",
    email_address: "",
    cell_number: "",
    m_payment_id: "",
    item_description: "",
    custom_int1: "",
    custom_str1: "",
    email_confirmation: "",
    confirmation_address: "",
    signature: "",
    payment_method: "",
  }

  const [formData, setFormData] = useState(initialState)
  const [validated, setValidated] = useState(false)

  const onChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  return (
    <Modal show={props.show} onHide={props.hide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          Please enter your <u>personal details</u>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form action={process.env.GATSBY_PAYFAST_LINK} method="post">
          <Form.Group>
            <Form.Control
              type="hidden"
              name="merchant_id"
              value={formData.merchant_id}
            />
          </Form.Group>
          <Form.Group>
            <Form.Control
              type="hidden"
              name="merchant_key"
              value={formData.merchant_key}
            />
          </Form.Group>
          <Form.Group>
            <Form.Control
              type="hidden"
              name="item_name"
              value={formData.item_name}
            />
          </Form.Group>
          <Form.Group>
            <Form.Control
              type="hidden"
              name="return_url"
              value={formData.return_url}
            />
          </Form.Group>
          <Form.Group>
            <Form.Control
              type="hidden"
              name="cancel_url"
              value={formData.cancel_url}
            />
          </Form.Group>
          <Form.Group>
            <Form.Control
              type="hidden"
              name="notify_url"
              value={formData.notify_url}
            />
          </Form.Group>

          <Form.Row>
            <Form.Group as={Col}>
              <Form.Label>First name:</Form.Label>
              <Form.Control
                required
                name="name_first"
                value={formData.name_first}
                onChange={onChange}
              />
            </Form.Group>

            <Form.Group as={Col}>
              <Form.Label>Last name:</Form.Label>
              <Form.Control
                required
                name="name_last"
                value={formData.name_last}
                onChange={onChange}
              />
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group as={Col}>
              <Form.Label>Email Address:</Form.Label>
              <Form.Control
                required
                type="email"
                name="email_address"
                value={formData.email_address}
                onChange={onChange}
              />
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group as={Col}>
              <Form.Label>Cell Number:</Form.Label>

              <Form.Control
                required
                type="tel"
                name="cell_number"
                value={formData.cell_number}
                onChange={onChange}
              />
            </Form.Group>
          </Form.Row>

          <Form.Group>
            <Form.Control
              type="hidden"
              name="m_payment_id"
              value={formData.m_payment_id}
            />
          </Form.Group>
          <Form.Group>
            <Form.Control type="hidden" name="amount" value={formData.amount} />
          </Form.Group>
          <Form.Group>
            <Form.Control
              type="hidden"
              name="item_name"
              value={formData.item_name}
            />
          </Form.Group>
          <Form.Group>
            <Form.Control
              type="hidden"
              name="item_description"
              value={formData.item_description}
            />
          </Form.Group>

          <Form.Group>
            <Form.Control type="hidden" name="custom_int1" value="2" />
          </Form.Group>
          <Form.Group>
            <Form.Control
              type="hidden"
              name="custom_str1"
              value={formData.custom_str1}
            />
          </Form.Group>

          <Form.Group>
            <Form.Control type="hidden" name="email_confirmation" value={1} />
          </Form.Group>
          <Form.Group>
            <Form.Control
              type="hidden"
              name="confirmation_address"
              value={formData.email_address}
            />
          </Form.Group>

          <Form.Group>
            <Form.Control
              type="hidden"
              name="signature"
              value={formData.signature}
            />
          </Form.Group>

          <Form.Group>
            <Form.Control
              type="hidden"
              name="payment_method"
              value={formData.payment_method}
            />
          </Form.Group>

          <Button type="submit" variant="powder">
            Move to payment ->
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  )
}

export default CheckoutModal
